import { useMemo } from 'react';

import { useCategoryTreeItem } from '../categoryTree';
import type { KuxFilteredCategoriesDTO, AssetPresentationRatioEnum } from '../compat/tvpil';

import { useImageSettings } from './useImageSettings';

export type UseTopShelfSettingsProps = {
  referenceId: string;
};

export type TopShelfSettings = {
  autoTransitionDelay: number;
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  coverImageType?: number;
  id: number;
  imageHeight?: number;
  imageRatio?: AssetPresentationRatioEnum;
  imageType?: number;
  imageWidth?: number;
  parentalPinProtected: boolean;
  shouldPresentEntitlementIndicator: boolean;
  shouldPresentRating: boolean;
  title: string;
};

export function useTopShelfSettings({ referenceId }: UseTopShelfSettingsProps): TopShelfSettings | undefined {
  const category = useCategoryTreeItem(referenceId);
  const imageSettings = useImageSettings({ referenceId });

  return useMemo(() => {
    if (!category?.topShelfCarousel) {
      return;
    }

    return {
      ...imageSettings,
      autoTransitionDelay: category.topShelfCarousel.autoTransitionDelay * 1000, // in ms
      branding: category.uiDesignElements,
      coverImageType: category.topShelfCarousel.coverImageType,
      id: category.id,
      parentalPinProtected: Boolean(category.parentalPinProtected),
      shouldPresentEntitlementIndicator: Boolean(category.asideProperty?.presentEntitlementIndicator),
      shouldPresentRating: Boolean(category.asideProperty?.presentRating),
      title: category.name,
    };
  }, [category, imageSettings]);
}
